import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommentModule } from '../comment/comment.module';

import { HomeComponent } from './home.component';

import { homeRoutes } from './home.routes';

@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    CommentModule,
    RouterModule.forChild(homeRoutes),
  ],
  providers: []

})
export class HomeModule {}



// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/home/home.module.ts